import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import Icon from '.././icons/icon'

const SimpleStateTag = props => {
  const classes = cx('state-tag', {
    ['is-type-' + props.type]: props.type,
    'has-background': props.hasBackground
  })
  return (
    <div className={classes}>
      <Icon name={props.iconName} />
      <span>{props.text}</span>
    </div>
  )
}

SimpleStateTag.propTypes = {
  type: PropTypes.oneOf(['success', 'warning', 'info']),
  hasBackground: PropTypes.bool,
  text: PropTypes.string,
  iconName: PropTypes.string
}

export default SimpleStateTag



// WEBPACK FOOTER //
// ./src/ui/tags/simple-state-tag.js